export const courseName = "全端開發兼讀制";

export const partTimeFacts = [
  {
    key: "classTime",
    label: "上課時間",
    value: "星期二/四/五 19:00 - 21:00；星期日 10:00 - 18:00",
  },
  {
    key: "hours",
    label: "修讀時數",
    value: "480小時（約12星期）",
  },
  {
    key: "location",
    label: "教室地址",
    value: "荔枝角",
  },
  {
    key: "price",
    label: "課程費用",
    value: "HK$9,000 起",
  },
  {
    key: "contentNote",
    label: "課程內容",
    value: "會因應就業市場需求而變動",
  },
  {
    key: "language",
    label: "教學語言",
    value: "廣東話",
  },
];

export const partTimeRequirements = {
  title: "入學要求",
  items: ["對IT 學習充滿熱誠", "準備從事 IT職業", "懂得電腦應用技巧", "良好中英文"],
};
